/**============================================================
*   [Class] パネル型記事スライダー
============================================================*/
export default class ArchiveSlider {
  constructor(
    target,
    key,
  )
  {
    this.swiperSlide = target;
    this.swiperKey = key;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-archive-'+ this.swiperKey);
    this.breakSmNum = 768;

    let swiperSlides = this.swiperSlide.getElementsByClassName('swiper-slide');
    this.swiperSlideItemNum = swiperSlides.length * 2;
    let slidable = swiperSlides.length > 1;
    let slidableSp = swiperSlides.length > 1;

    const pagination = this.swiperSlide.dataset.sliderMode == 'banner' ? '.swiper-archive-'+ key + ' ~ .l-container .p-nav-swiper-container .swiper-pagination' : '.swiper-archive-'+ key + ' + .p-nav-swiper-container .swiper-pagination';

    const nextEl = this.swiperSlide.dataset.sliderMode == 'banner' ? '.swiper-archive-'+ key + ' ~ .l-container .p-nav-swiper-container .swiper-button-next' : '.swiper-archive-'+ key + ' + .p-nav-swiper-container .swiper-button-next';

    const prevEl = this.swiperSlide.dataset.sliderMode == 'banner' ? '.swiper-archive-'+ key + ' ~ .l-container .p-nav-swiper-container .swiper-button-prev' : '.swiper-archive-'+ key + ' + .p-nav-swiper-container .swiper-button-prev';

    this.initSwiper = () => {
      this.mySwiper = new Swiper(this.swiperSlide, {
        slidesPerView: 'auto',
        loop: slidableSp,
        loopAdditionalSlides: this.swiperSlideItemNum,
        loopPreventsSlide: true,
        watchOverflow: !slidable,
        pagination: {
            el: pagination,
            type: 'bullets',
            clickable: true
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        on: {
          init: (swiper) => {
            //modal設定用
            document.dispatchEvent(new CustomEvent('objInit', {
              detail: swiper,
            }));
          }
        }
      });
    };
    this.initSwiper();
  }
}
